import { Button, CircularProgress, Typography } from "@mui/material";
import { DropzoneArea } from "material-ui-dropzone";
import { useState } from "react";
import GenericModal from "../../Modal/GenericModal";
import { TaskModel } from "../../Models/Models";
import styles from "../../Styles/modalServices.module.css";
import { Vocabulary } from "../../Utils/Vocabulary";

type Props = {
  open: boolean;
  task: TaskModel;
  onClose: () => void;
  onConfirm: (file: File) => Promise<void>;
};

export default function TaskDocGateDialog({ open, onClose, onConfirm }: Props) {
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);

  async function handleConfirm() {
    if (!file) return;
    setUploading(true);
    try {
      await onConfirm(file);
    } finally {
      setUploading(false);
      setFile(null);
    }
  }

  function handleClose() {
    if (uploading) return;
    setFile(null);
    onClose();
  }

  const buttons = (
    <>
      <Button onClick={handleClose} disabled={uploading}>
        {Vocabulary.cancel}
      </Button>
      <Button
        variant="contained"
        color="primary"
        disabled={!file || uploading}
        onClick={handleConfirm}
        startIcon={uploading ? <CircularProgress size={16} color="inherit" /> : null}
      >
        {Vocabulary.taskDocGateConfirm}
      </Button>
    </>
  );

  return (
    <GenericModal
      open={open}
      onClose={handleClose}
      title={Vocabulary.taskDocGateTitle}
      maxWidth={700}
      buttons={buttons}
    >
      <>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16, textAlign: "center" }}>
          {Vocabulary.taskDocGateMessage}
        </Typography>
        <DropzoneArea
          acceptedFiles={["image/*,application/*"]}
          dropzoneClass={styles.dropzoneArea}
          dropzoneText={Vocabulary.dragAndDrop}
          getFileAddedMessage={() => Vocabulary.fileSuccessfullyAdded}
          maxFileSize={30000000}
          filesLimit={1}
          onChange={(files) => setFile(files[0] ?? null)}
          onDelete={() => setFile(null)}
        />
      </>
    </GenericModal>
  );
}
